import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import LogRocket from 'logrocket';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import LogrocketFuzzySanitizerModified from './vendors/logrocket-fuzzy-search-sanitizer-master/src/index';

if (environment.production) {
  enableProdMode();
}
console.log('env: ', environment.environmentName);

const privateFieldNames = [
  'note',
  'completedBy',
  'validationToken',
  'validationTokenId',
  'token',
  'expiration',
  'boolean',
  'comments',
  'rating',
  'textResponse',
  'name',
  'firstName',
  'lastName',
  'title',
  'email',
  'phone',
  'clientRepName',
  'attorneyName',
  'attorneyContactNumber',
  'attorneyContactEmail',
  'clientContactNumber',
  'clientContactEmail',
  'message',
  'notes',
  'matterName',
  'attorney',
  'value',
  'type',
  'text',
  'shortQuestionText',
  'completedBy',
  'ratingType',
  'surveyType',
  'surveyContact',
];

const { requestSanitizer, responseSanitizer }: any =
  LogrocketFuzzySanitizerModified.setup([...privateFieldNames]);

if (environment.useLogRocket && environment.useLogRocket === true) {
  switch (environment.environmentName) {
    case 'dev':
      LogRocket.init('rwd7hs/lexsurvey-dev', {
        dom: {
          inputSanitizer: 'lipsum',
        },
        network: {
          requestSanitizer,
          responseSanitizer,
        },
      });
      break;
    case 'qa':
      LogRocket.init('rwd7hs/lexsurvey-qa', {
        dom: {
          inputSanitizer: 'lipsum',
        },
        network: {
          requestSanitizer,
          responseSanitizer,
        },
      });
      break;
    case 'prod':
      LogRocket.init('rwd7hs/lexsurvey', {
        dom: {
          inputSanitizer: 'lipsum',
        },
        network: {
          requestSanitizer,
          responseSanitizer,
        },
      });
      break;
    default:
      break;
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
